module.exports = __webpack_public_path__ + "static/img/sc_light.688033b.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/sc_light.png
// module id = nTnH
// module chunks = 1